export const OPTANON_CONSENT_COOKIE = 'OptanonConsent';

const decodeOptanonConsentValue = consentValue => {
  if (!consentValue) {
    return null;
  }

  try {
    return decodeURIComponent(consentValue);
  } catch {
    return consentValue;
  }
};

export const parseOptanonConsentGroups = consentValue => {
  const decodedConsentValue = decodeOptanonConsentValue(consentValue);
  if (!decodedConsentValue) {
    return null;
  }

  const groupsMatch = decodedConsentValue.match(/groups=([^&]+)/);
  if (!groupsMatch?.[1]) {
    return null;
  }

  try {
    return decodeURIComponent(groupsMatch[1])
      .split(',')
      .filter(Boolean);
  } catch {
    return groupsMatch[1].split(',').filter(Boolean);
  }
};

export const hasAnalyticsConsentFromOptanonValue = consentValue => {
  const groups = parseOptanonConsentGroups(consentValue);

  if (!groups) {
    return null;
  }

  // The cookie also lists rejected groups (C0002:0), unlike OnetrustActiveGroups
  const activeGroups = groups.filter(group => group.endsWith(':1'));

  // Mirrors the client-side OneTrust heuristic: more than four active groups
  // means the user accepted the full analytics set.
  return activeGroups.length > 4;
};

export const hasAnalyticsConsentFromCookieStore = cookieStore =>
  hasAnalyticsConsentFromOptanonValue(
    cookieStore.get(OPTANON_CONSENT_COOKIE)?.value
  );

export default hasAnalyticsConsentFromCookieStore;
